import { booleanAttribute, ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { DsMessageModule } from '@bmw-ds/components';

import { Customer } from '../../customer/model/customer.model';
import { useI18n } from '../../i18n/services/i18n.service';
import { LoadingIndicatorComponent } from '../../loading/loading-indicator.component';
import { ProfileInfoGridComponent } from './profile-info-grid/profile-info-grid.component';

@Component({
  selector: 'cdf-profile',
  imports: [DsMessageModule, LoadingIndicatorComponent, ProfileInfoGridComponent],
  template: `
    @if (customer(); as customer) {
      <cdf-profile-info-grid
        [(successfullyInitializedIdCreation)]="successfullyInitializedIdCreation"
        [customer]="customer"
        [readonly]="readonly()"
        (editCustomer)="editCustomer.emit()"
      />
    } @else if (loading()) {
      <cdf-loading-indicator>{{ i18n('profile.loading') }}</cdf-loading-indicator>
    } @else if (connectionError()) {
      <ds-message tone="caution" [messageText]="i18n('profile.connectionError')" />
    } @else {
      <ds-message tone="caution" [messageText]="i18n('profile.notFound')" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent {
  protected readonly i18n = useI18n();

  readonly customer = input.required<Customer | undefined>();
  readonly loading = input(false, { transform: booleanAttribute });
  readonly connectionError = input(false, { transform: booleanAttribute });
  readonly readonly = input(false);

  readonly successfullyInitializedIdCreation = model<boolean>();

  readonly editCustomer = output();
}
